import styled from 'styled-components';
import { grey150, chartOrange, brandColors } from 'styles/colors';

export const ActionsWrapper = styled.div`
	padding: 0px 30px;
	display: flex;
	height: 48px;
	align-items: center;
	border-bottom: 3px solid ${brandColors.green};

	${({ isUnpublished }) => isUnpublished && `border-color: ${chartOrange}`};
`;

export const RightSection = styled.div`
	margin-left: auto;
`;

export const ActionItem = styled.div`
	padding: 0 8px;
	margin: 0 3px;
`;

export const Divider = styled.div`
	border-left: 1px solid ${grey150};
	height: 24px;
	margin: 0 5px;
	align-self: center;
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	.ag-theme-balham {
		.ag-root,
		.ag-side-bar {
			border-top: none;
			border-bottom: none;
		}
	}

	height: 100%;
`;
